// extracted by mini-css-extract-plugin
export default {"cta":"DownloadOrderPdf_cta__rv5Hc","hidden-trigger":"DownloadOrderPdf_hidden-trigger__pzTyW"};